import { MainInner } from "@/styles/global";
import { Paragraph, h2, h4 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Inner = styled(MainInner)`
  gap: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 28px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 28px;
  }
`;

const Title = styled(h2)`
  max-width: 820px;
`;

const Text = styled(Paragraph)`
  max-width: 820px;
`;

const CardsWrapper = styled.div<{ $arrayLength: number }>`
  display: grid;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 28px;
    ${({ $arrayLength }) =>
      $arrayLength === 2
        ? "grid-template-columns: repeat(auto-fill, minmax(calc(50% - 16px), 1fr));"
        : "grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));"}
  }
`;

const Card = styled.div<{ $bgColor: string }>`
  border-radius: 4px;
  background-color: ${({ $bgColor }) => $bgColor};
  min-width: 300px;
  min-height: 217px;
  display: flex;
  flex-direction: column;
`;

const TextWrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 100%;
  }
`;

const CardTitle = styled(h4)``;

const CardImage = styled(GatsbyImage)`
  border-radius: 4px 4px 0 0;
  aspect-ratio: 1/1;
  min-height: 250px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    aspect-ratio: 5/3;
    min-height: 300px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: auto;
`;

const S = {
  Inner,
  TitleWrapper,
  Title,
  CardsWrapper,
  Card,
  TextWrapper,
  CardTitle,
  CardImage,
  Text,
  ButtonWrapper,
};

export default S;
